import React from 'react';
import cl from "./PrepodsListCase.module.css";
import edles from "../../../../images/Eldas-150x150.jpg";
import { Teacher } from '../../../../api/api'; // Импортируем из api.ts

interface PrepodsListCaseProps {
    prepod: Teacher;
}

const PrepodsListCase: React.FC<PrepodsListCaseProps> = ({ prepod }) => {
    return (
        <div className={cl.eruditCardTeacher}>
            <div className={cl.eruditCardTeacher__img}>
                <img
                    src={prepod.image
                        ? (prepod.image.startsWith('data:')
                            ? prepod.image
                            : `data:image/jpeg;base64,${prepod.image}`)
                        : edles}
                    alt={prepod.name}
                />
            </div>
            <span className={cl.eruditCardTeacher__badge}>{prepod.position}</span>
            <h3 className={cl.eruditCardTeacher__title}>
                {prepod.name}
            </h3>
            <div className={cl.eruditCardTeacher__rule}>
                {prepod.grade}
            </div>
            <div className={cl.eruditCardTeacher__ruleFull}>
                {prepod.positionFull}
            </div>
            <div className={cl.eruditCardTeacher__description}>
                {prepod.description}
            </div>
        </div>
    );
};

export default PrepodsListCase;